import { useEffect, useState } from 'react';
import BackWithSidebar from '../../../../components/BackWithSidebar';
import GeneralIcon from '../../../../assets/index';
import SearchBar from '../../../../components/SearchBar';

const STORAGE_KEY = 'perguntas_list_v1';

export default function Perguntas() {
  const [items, setItems] = useState([]);
  const [query, setQuery] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [editingIndex, setEditingIndex] = useState(null);
  const [question, setQuestion] = useState('');
  const [answer, setAnswer] = useState('');
  const [showConfirm, setShowConfirm] = useState(false);
  const [toDeleteIndex, setToDeleteIndex] = useState(null);
  const [duplicateError, setDuplicateError] = useState('');

  useEffect(() => {
    try {
      const raw = window.localStorage.getItem(STORAGE_KEY);
      if (raw) setItems(JSON.parse(raw));
    } catch (e) {
      // ignore
    }
  }, []);

  useEffect(() => {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {}
  }, [items]);

  const filtered = items.filter((it) => {
    if (!query) return true;
    const q = query.trim().toLowerCase();
    return (it.question || '').toLowerCase().includes(q) || (it.answer || '').toLowerCase().includes(q);
  });

  function openAdd() {
    setEditingIndex(null);
    setQuestion('');
    setAnswer('');
    setDuplicateError('');
    setShowModal(true);
  }

  function openEdit(idx) {
    const it = items[idx];
    setEditingIndex(idx);
    setQuestion(it.question || '');
    setAnswer(it.answer || '');
    setDuplicateError('');
    setShowModal(true);
  }

  function confirmDelete(idx) {
    setToDeleteIndex(idx);
    setShowConfirm(true);
  }

  function doDelete() {
    if (toDeleteIndex === null) return;
    const next = items.filter((_, i) => i !== toDeleteIndex);
    setItems(next);
    setShowConfirm(false);
    setToDeleteIndex(null);
  }

  function validateDuplicate(text) {
    const t = (text || '').trim().toLowerCase();
    if (!t) return false;
    const exists = items.some((it, i) => it.question.trim().toLowerCase() === t && i !== editingIndex);
    return exists;
  }

  function handleSave(e) {
    e && e.preventDefault();
    setDuplicateError('');
    if (!question.trim()) {
      setDuplicateError('Pergunta não pode ser vazia.');
      return;
    }
    const isDup = validateDuplicate(question);
    if (isDup) {
      setDuplicateError('Essa pergunta já existe.');
      return;
    }
    const payload = { question: question.trim(), answer: answer.trim() };
    if (editingIndex === null) setItems((s) => [...s, payload]);
    else setItems((s) => s.map((it, i) => (i === editingIndex ? payload : it)));
    setShowModal(false);
  }

  return (
    <div className="min-h-screen bg-white p-4">
      <div className="max-w-lg mx-auto">
        <div className="flex items-center gap-3 mb-6">
          <BackWithSidebar />
          <h1 className="text-lg font-semibold">Perguntas e Respostas</h1>
        </div>

        <div className="mb-4">
          <SearchBar
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Pesquisar por pergunta"
            className="w-full"
          />
        </div>

        <div className="text-sm text-gray-600 mb-3">Encontramos {filtered.length} resultados</div>

        {filtered.length > 0 ? (
          <div className="space-y-3">
            {filtered.map((it, idx) => (
              <div key={idx} className="bg-white border rounded p-4 shadow-sm">
                <div className="flex items-start justify-between gap-3">
                  <div>
                    <div className="font-medium mb-2">{it.question}</div>
                    <div className="text-sm text-gray-700 whitespace-pre-line">{it.answer}</div>
                  </div>
                  <div className="flex flex-col items-end gap-2">
                    <button onClick={() => openEdit(idx)} className="p-2 rounded-md bg-purple-50 text-purple-700"><GeneralIcon iconName="editar" className="w-5 h-5" /></button>
                    <button onClick={() => confirmDelete(idx)} className="p-2 rounded-md bg-red-50 text-red-600"> <GeneralIcon iconName="lixeira" className="w-5 h-5" /></button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-12">
            <div className="w-full flex justify-center mb-6">
              <GeneralIcon iconName="vazio" className="w-40 h-40" />
            </div>
            <div className="text-lg font-medium">Vazio!</div>
            <div className="text-sm text-gray-500">Você não tem perguntas cadastradas.</div>
          </div>
        )}

        {/* Add button fixed bottom */}
        <div className="fixed left-0 right-0 bottom-4 flex justify-center pointer-events-none">
          <div className="w-full max-w-lg px-4 pointer-events-auto">
            <button onClick={openAdd} className="w-full inline-flex items-center justify-center gap-2 py-3 bg-purple-600 text-white rounded shadow-lg">
              <span className="text-lg">+</span>
              <span className="text-sm">Adicionar uma nova pergunta</span>
            </button>
          </div>
        </div>

        {/* Modal Add/Edit */}
        {showModal && (
          <div className="fixed inset-0 flex items-end md:items-center justify-center z-50">
            <div className="absolute inset-0 bg-black bg-opacity-40" onClick={() => setShowModal(false)} />
            <form onSubmit={handleSave} className="relative w-full max-w-md bg-white rounded-t-xl md:rounded-xl p-6">
              <h2 className="mb-4 font-semibold">{editingIndex === null ? 'Adicionar pergunta' : 'Editar pergunta'}</h2>
              <div className="mb-3 text-sm text-purple-600 bg-purple-50 p-3 rounded flex gap-3 items-start">
                <div className="w-10 flex-shrink-0 text-center">
                  <GeneralIcon iconName="dica" className="w-8 h-8 mx-auto" />
                  <strong className="block">DICA</strong>
                </div>
                <div>
                  
                  <div>Adicione as perguntas que os clientes mais fazem a você. Elas sempre serão exibidas no perfil da loja.</div>
                </div>
              </div>

              <div className="mb-3">
                <label className="block text-sm mb-1">Pergunta*</label>
                <input placeholder='Peixes podem voar?' value={question} onChange={(e) => setQuestion(e.target.value)} className="w-full p-2 border rounded" />
              </div>

              <div className="mb-3">
                <label className="block text-sm mb-1">Resposta*</label>
                <textarea placeholder='Depende do preço.' value={answer} onChange={(e) => setAnswer(e.target.value)} className="w-full p-2 border rounded h-28" />
              </div>

              {duplicateError && <div className="mb-3 text-sm text-red-600 text-center rounded p-2">{duplicateError}</div>}

              <div className="flex gap-2">
                <button type="button" onClick={() => setShowModal(false)} className="flex-1 py-2 border rounded">Cancelar</button>
                <button type="submit" className="flex-1 py-2 bg-purple-600 text-white rounded">{editingIndex === null ? 'Adicionar' : 'Atualizar'}</button>
              </div>
            </form>
          </div>
        )}

        {/* Delete confirm */ }
        {showConfirm && (
          <div className="fixed inset-0 flex items-center justify-center z-50">
            <div className="absolute inset-0 bg-black bg-opacity-40" onClick={() => setShowConfirm(false)} />
            <div className="relative w-full max-w-xs bg-white rounded p-4">
              <h3 className="font-semibold mb-2">Excluir pergunta</h3>
              <p className="text-sm text-gray-700 mb-4">Você tem certeza que deseja excluir esta pergunta?</p>
              <div className="flex gap-2">
                <button onClick={() => setShowConfirm(false)} className="flex-1 py-2 border rounded">Cancelar</button>
                <button onClick={doDelete} className="flex-1 py-2 bg-red-100 text-red-600 rounded">Excluir</button>
              </div>
            </div>
          </div>
        )}

      </div>
    </div>
  );
}
